/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ArrowCounterClockwise(props) {
  return (
    <Icon {...props}>
      <path d="M6.35146967,6.35 C7.80237649,4.9 9.79362101,4 12.0050031,4 C16.4277674,4 20,7.58 20,12 C20,16.42 16.4277674,20 12.0050031,20 C8.27267042,20 5.16072545,17.45 4.27016886,14 L6.35146967,14 C7.17198249,16.33 9.39337086,18 12.0050031,18 C15.3170732,18 18.0087555,15.31 18.0087555,12 C18.0087555,8.69 15.3170732,6 12.0050031,6 C10.343965,6 8.8630394,6.69 7.78236398,7.78 L11.0043777,11 L4,11 L4,4 L6.35146967,6.35 Z" id="Path" />
    </Icon>
  )
}

ArrowCounterClockwise.tags = ['Revert']
ArrowCounterClockwise.category = categories.actions

export default ArrowCounterClockwise
